import React from "react";
import './banner.scss';


const Banner = ({ title, categories }) => {
  return (
    <>
      <div className="page">
        <div>
          <h2>{title}</h2>
          <h5>
            <i className="fas fa-home fa-1x"></i> Home/{categories}{title}
          </h5>
        </div>
      </div>
    </>
  );
};

export default Banner;
